function normalizeCNPJ(value: string): string {
  const cleaned = value.replace(/[.\-/\s]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const base = cleaned.slice(0, 12);
  const checkDigits = cleaned.slice(12).replace(/\D/g, '').slice(0, 2);
  return `${base}${checkDigits}`;
}

/**
 * Format CNPJ as AA.AAA.AAA/AAAA-DV.
 * The first 12 characters accept A-Z and 0-9; the two check digits stay numeric.
 */
export function formatCNPJ(value: string): string {
  const normalized = normalizeCNPJ(value);

  if (normalized.length <= 2) return normalized;
  if (normalized.length <= 5) return `${normalized.slice(0, 2)}.${normalized.slice(2)}`;
  if (normalized.length <= 8) return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(5)}`;
  if (normalized.length <= 12)
    return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(5, 8)}/${normalized.slice(8)}`;
  return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(5, 8)}/${normalized.slice(8, 12)}-${normalized.slice(12)}`;
}

export function stripCNPJ(value: string): string {
  return normalizeCNPJ(value);
}
